import React, { useState } from "react";
import PropTypes from "prop-types";

import "./TitleSection.css";

function TitleSection(props) {
  const {
    lightBg,
    lightText,
    lightTextDesc,
    headlineOne,
    headlineTwo,
    description,
    src,
    alt,
    imgStart,
  } = props;

  const [image, setImage] = useState(window.innerWidth < 0 ? false : true);

  const showImage = () => {
    if (window.innerWidth < 0) {
      setImage(false);
    } else {
      setImage(true);
    }
  };

  window.addEventListener("resize", showImage);

  return (
    <>
      <div
        className={lightBg ? "title__section" : "title__section title--darkBg"}
      >
        <div className="title__container">
          <div
            className="title__row"
            style={{
              display: "flex",
              flexDirection: imgStart == "start" ? "row-reverse" : "row",
            }}
          >
            <div className="title__col">
              <div className="title__text-wrapper">
                <h1
                  className={
                    lightText ? "title__heading" : "title-heading title--dark"
                  }
                >
                  <span className="title__heading-span">{headlineOne}</span>
                  <span className="title__heading-span">{headlineTwo}</span>
                </h1>
                <p
                  className={
                    lightTextDesc
                      ? "title__subtitle"
                      : "title__subtitle title--dark"
                  }
                >
                  {description}
                </p>
                <div className="title__download-row">
                  <div className="title__playstore-img-wrapper">
                    <a href="https://play.google.com/store/apps/details?id=jp.workom">
                      <img
                        src="images/googleplay.png"
                        alt="Google Play で手に入れよう"
                        className="title__playstore-img"
                      />
                    </a>
                  </div>
                  <div className="title__appstore-img-wrapper">
                    <a href="https://apps.apple.com/jp/app/workom-%E6%96%B0%E3%81%97%E3%81%84%E5%8C%BF%E5%90%8Dsns%E3%81%A7%E7%A4%BE%E4%BC%9A%E4%BA%BA%E3%81%A8%E4%BA%A4%E6%B5%81%E3%81%97%E3%82%88%E3%81%86/id1601043751?itsct=apps_box_link&itscg=30200">
                      <img
                        src="images/appstore.svg"
                        alt="App Store からダウンロード"
                        className="title__appstore-img"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {image ? (
              <div className="title__col">
                <div className="title__img-wrapper">
                  <img src={src} alt={alt} className="title__img" />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

TitleSection.propTypes = {
  lightBg: PropTypes.bool,
  lightText: PropTypes.bool,
  lightTextDesc: PropTypes.bool,
  headlineOne: PropTypes.string,
  headlineTwo: PropTypes.string,
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  imgStart: PropTypes.string,
};

export default TitleSection;
